import React from 'react';
import {
  ComboBox as KendoComboBox,
  ComboBoxFilterChangeEvent,
  ComboBoxChangeEvent,
  ListItemProps
} from '@progress/kendo-react-dropdowns';

type KendoReactComboBoxProps<T> = {
  data: T[];
  textField: string;
  dataItemKey: string;
  placeholder: string;
  value: T | null;
  disabled?: boolean;
  inputId?: string;
  className?: string;
  popupClassName?: string;
  filterable?: boolean;
  clearButton?: boolean;
  testId?: string;
  loading?: boolean;
  itemRender?: (
    li: React.ReactElement<HTMLLIElement>,
    itemProps: ListItemProps
  ) => React.ReactNode;
  onFilterChange?: (event: ComboBoxFilterChangeEvent) => void;
  onChange: (event: ComboBoxChangeEvent) => void;
};

export const KendoReactComboBox = <T,>(props: KendoReactComboBoxProps<T>) => {
  const {
    data,
    textField,
    dataItemKey,
    placeholder,
    value,
    disabled = false,
    inputId = '',
    className = '',
    popupClassName,
    filterable = true,
    clearButton = false,
    testId,
    loading = false,
    itemRender,
    onFilterChange,
    onChange
  } = props;

  return (
    <>
      <div
        className="kendo-react-combo-box"
        data-testid={testId ?? 'kendo-react-combo-box'}
      >
        <link
          href="https://kendo.cdn.telerik.com/themes/7.0.1/material/material-main.css"
          rel="stylesheet"
          type="text/css"
        />
        <KendoComboBox
          className={'kendo-react-combobox ' + className}
          id={inputId}
          popupSettings={
            popupClassName ? { className: popupClassName } : undefined
          }
          data={data}
          textField={textField}
          dataItemKey={dataItemKey}
          placeholder={placeholder}
          value={value}
          filterable={filterable}
          clearButton={clearButton}
          disabled={disabled}
          loading={loading}
          itemRender={itemRender}
          onFilterChange={onFilterChange}
          onChange={onChange}
        />
      </div>
    </>
  );
};
